import { render, staticRenderFns } from "./ModerateCandidateDialog.vue?vue&type=template&id=757a6b80&scoped=true"
import script from "./ModerateCandidateDialog.vue?vue&type=script&lang=js"
export * from "./ModerateCandidateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a6b80",
  null
  
)

export default component.exports